






































































































































































// Import vendors ----------------------------------------------------------------------------------
import { defineComponent, computed, reactive } from '@vue/composition-api';
// Import components -------------------------------------------------------------------------------
import ChartEvolutionStanceTime from '@/components/charts/evolution/ChartEvolutionStanceTime.vue';
import ChartEvolutionSwingTime from '@/components/charts/evolution/ChartEvolutionSwingTime.vue';
import ChartEvolutionStrideLength from '@/components/charts/evolution/ChartEvolutionStrideLength.vue';
import ChartEvolutionSpeed from '@/components/charts/evolution/ChartEvolutionSpeed.vue';
import ChartEvolutionCadence from '@/components/charts/evolution/ChartEvolutionCadence.vue';
import ChartEvolutionSymmetry from '@/components/charts/evolution/ChartEvolutionSymmetry.vue';
import ChartEvolutionPropulsionRate from '@/components/charts/evolution/ChartEvolutionPropulsionRate.vue';
import ChartEvolutionClearance from '@/components/charts/evolution/ChartEvolutionClearance.vue';
import ChartEvolutionAttackAngle from '@/components/charts/evolution/ChartEvolutionAttackAngle.vue';
import ChartEvolutionHeelStrike from '@/components/charts/evolution/ChartEvolutionHeelStrike.vue';
import ChartEvolutionFlatFoot from '@/components/charts/evolution/ChartEvolutionFlatFoot.vue';
import ChartEvolutionHeelOff from '@/components/charts/evolution/ChartEvolutionHeelOff.vue';
import ChartEvolutionToesOff from '@/components/charts/evolution/ChartEvolutionToesOff.vue';
import ChartEvolutionWalkingPhases from '@/components/charts/evolution/ChartEvolutionWalkingPhases.vue';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'ChartEvolutionGroupsWalking',
  components: {
    ChartEvolutionStanceTime,
    ChartEvolutionSwingTime,
    ChartEvolutionStrideLength,
    ChartEvolutionSpeed,
    ChartEvolutionCadence,
    ChartEvolutionSymmetry,
    ChartEvolutionPropulsionRate,
    ChartEvolutionClearance,
    ChartEvolutionAttackAngle,
    ChartEvolutionHeelStrike,
    ChartEvolutionFlatFoot,
    ChartEvolutionHeelOff,
    ChartEvolutionToesOff,
    ChartEvolutionWalkingPhases
  },
  props: {
    values: {
      type: Object,
      required: true
    },
    relative: {
      type: Boolean,
      required: true
    }
  },
  setup(properties) {
    const aggregates = computed(() => properties.values.data.aggregates);
    const norms = computed(() => properties.values.data.norms);
    const manifest = computed(() => properties.values.analysisManifests);

    const modes = reactive({
      standard: true,
      advanced: false
    });

    return {
      aggregates,
      norms,
      manifest,
      modes
    };
  }
});
